import styled from 'styled-components';
export const Container = styled.div`
  overflow: hidden;
  height: 100vh;
`;

export const Body = styled.div`
  flex-direction: column;
  display: flex;
  align-items: center;
  height: calc(100vh - 48px);
  background: #52595c;
  padding-top: 2rem;
  overflow: hidden;

  input[type='password']::-ms-reveal,
  input[type='password']::-ms-clear {
    display: none;
  }

  label {
    margin-top: 3rem;
  }

  .options-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: relative;
    margin-top: 3rem;
    overflow: visible;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 1rem;
      align-items: center;
    }
  }

  .validation-system {
    text-align: center;
    font-weight: 800;
    font-size: 44px;
  }

  .card-approach {
    font-weight: 700;
    font-size: 32px;
  }

  @media (min-height: 800px) {
    label {
      margin-top: 4rem;
    }
  }
`;

export const Logo = styled.img`
  width: 33%;
  margin: 3rem 0;
`;

export const Title = styled.h1`
  color: white;
  text-align: center;
  font-weight: 800;
  font-size: 44px;
  margin: 0;
  text-transform: uppercase;
`;

export const Modal = {
  position: 'absolute' as const,
  top: '30%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

export const VoucherButton = styled.button`
  padding: 14px;
  max-width: 220px;
  border-radius: 14px;
  border: none;
  cursor: pointer;
  font-size: 28px;
  text-transform: uppercase;
  background: #faef00;
  color: #000;
  font-weight: 800;
  align-self: flex-end;

  :focus {
    outline: none;
  }
`;
